import React, { useState } from 'react';
import '../Styles/admin.css'
import { Link } from 'react-router-dom';



const SignupAdmin = () => {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [companyEmail, setCompanyEmail] = useState("");
    const [companySize, setCompanySize] = useState("");
    const [aboutCompany, setAboutCompany] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log({ firstName, lastName, companyName, companyEmail, companySize, aboutCompany });
      };

return (
<div className='signup'>
    <div className="header-top">
        <div className='texxt'>
            <h2>Already have an account?</h2>
            <h2><Link to='/pop'>Sign Up</Link></h2>
        </div>
    </div>

    <div className="welocme">
        <div className="text">
            <h1 className="title">Welcome To Melody.AI</h1>
            <h2 className="subtitle">Sign up to get started</h2>
        </div>

        <form action="" className='form'>
            <div>
                <label>
                First Name:
                <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                </label>
                
                <label>
                Last Name:
                <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                </label>
            </div>
        
            <div>
                <label>
                Company Name:
                <input type="text" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                </label>
                
                <label>
                Company Email:
                <input type="email" value={companyEmail} onChange={(e) => setCompanyEmail(e.target.value)} />
                </label>
            </div>
        
            <div>
                <label>
                    Company Size:
                    <input type="number" value={companySize} onChange={(e) => setCompanySize(e.target.value)} />
                </label>  

                <label>
                    Company Size:
                    <input type="number" value={companySize} onChange={(e) => setCompanySize(e.target.value)} />
                </label> 
            </div>

            <div className="textarea">
                <p>About Company:</p> 
                <textarea value={aboutCompany} onChange={(e) => setAboutCompany(e.target.value)} />
            </div>
        
        
            <button type="submit">Submit</button>
        </form>    
    </div>
</div>
);
}

export default SignupAdmin;